import 'whatwg-fetch';
import 'url-search-params-polyfill';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// SheerID stuff
import { setOptions, overrideComponent, setMetadata } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';

import { StepStudentPersonalInfoComponent } from './components/stepComponents/StepStudentPersonalInfo/StepStudentPersonalInfoComponent';
import { StepSuccessComponent } from './components/stepComponents/StepSuccess/StepSuccessComponent';
import { StepPendingComponent } from './components/stepComponents/StepPending/StepPendingComponent';
import { StepErrorComponent } from './components/stepComponents/StepError/StepErrorComponent';
import { addMajorValidator, addMinorValidator } from './lib/validators/validators';

// @ts-ignore
overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);
// @ts-ignore
overrideComponent('StepPendingComponent', StepPendingComponent);
// @ts-ignore
overrideComponent('StepErrorComponent', StepErrorComponent);

setOptions(defaultOptions);
googleTagManagerHook();

setMetadata({ major: '', minor: '' });

addMajorValidator();
addMinorValidator();

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
